angular.module('controllers').controller('ingredientController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog', '$filter', '$route', '$routeParams', '$location', '$timeout', '$window',
    function ($scope, $rootScope, $controller, Crud, $mdDialog, $filter, $route, $routeParams, $location, $timeout, $window) {
		$rootScope.path = '/ingredient';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'ingredient';
		$scope.pathTemplate = 'food/ingredients';
		$scope.title = 'Ingrediente';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'ingredient_name';
		$scope.defaultItem = 10;
    $rootScope.typeId = 'id';
		$scope.search.order = 'asc';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'ingredient_name':{'label':'Nume', 'filter':1, 'filterType':'input'},
      'ingredient_unit':{'label':'Unitate', 'filter':1, 'filterType':'input'},
      'ingredient_quantity_unit':{'label':'Cantitate', 'filter':1, 'filterType':'input'},
      'ingredient_tva':{'label':'TVA', 'filter':1, 'filterType':'input'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

		$scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'ingredient_name';

        $scope.additionals['type_orders'] = [
            {'value' : 'order_active', 'name' : 'Comenzi active'},
            {'value' : 'order_cancelled', 'name' : 'Comenzi anulate'}
        ];

        $scope.additionals['order_status'] = [
    				{'id': 2, 'value': 'Anulata', 'color': 'rgba(193, 32, 38, 0.5)', 'color-even': 'rgba(193, 32, 38, 0.3)'}, //red
    				{
    						'id': 3,
    						'value': 'Trimisa spre livrare',
    						'color': 'rgba(222, 96, 27, 0.5)',
    						'color-even': 'rgba(222, 96, 27, 0.3)'
    				}, //brown
    				{
    						'id': 4,
    						'value': 'Curs de livrare',
    						'color': 'rgba(169, 215, 65, 0.9)',
    						'color-even': 'rgba(169, 215, 65, 0.7)'
    				}, //green
    				{'id': 5, 'value': 'Livrata', 'color': 'rgba(0, 51, 153, 0.4)', 'color-even': 'rgba(0, 51, 153, 0.2)'}, //blue
    				{'id': 6, 'value': 'Anulata sofer/ospatar', 'color': 'rgba(90, 87, 87, 0.8)', 'color-even': 'rgba(90, 87, 87, 0.6)'},//black
            {'id': 7, 'value': 'Stand by', 'color': 'rgba(160, 160, 160, 0.8)', 'color-even': 'rgba(160, 160, 160, 0.6)'}//dark grey
    		];

        $scope.recipeUnits = {};
        $scope.recipeUnits.options = [
            {'id':0, 'value' : ''},
            {'id':1, 'value' : 'kg'},
            {'id':2, 'value' : 'l'},
            {'id':3, 'value' : 'buc'}
        ];
        $scope.additionals['recipeUnits'] = $scope.recipeUnits;

        $scope.additionals['status_string'] = JSON.stringify($scope.columns.status.options);
        $scope.additionals['recipe_unit_string'] = JSON.stringify($scope.recipeUnits.options);

        /* get dependent fields */
        $scope.dependedFields = [];
        $scope.getDependedFields = function () {
          Crud.getDependedFields($scope.path)
            .success(function (data) {
                $scope.dependedFields.push(data);

                $scope.additionals['goodsCategories'] = data.goodsCategories;
                $scope.additionals['foodProductFamilies'] = data.foodProductFamilies;

                $scope.additionals['dependedFields'] = $scope.dependedFields[0];
            });
        }

        $scope.additionals['searchTerm'];
        $scope.additionals['clearSearchTerm'] = function() {
            $scope.additionals['searchTerm'] = '';
        };
        $scope.additionals['onSearchChange'] = function(ev) {
            ev.stopPropagation();
        };

        $scope.maxDate = new Date();
        $scope.minDate = '2010-01-01';
        var current_init_date = new Date();
        current_init_date.setHours(0,0,0,0);
        $scope.search.dateFrom = current_init_date;

        $scope.additionals['functionResult'] = function(ev, data) {

            if (!angular.isUndefined($scope.modelData.ingredient_name)) {
                $scope.modelData.ingredient_name = $scope.modelData.ingredient_name.toLowerCase();
            }
            if (!angular.isUndefined($scope.additionals['searchTermGoodsCategory'])) {
      					$scope.additionals['searchTermGoodsCategory'] = '';
      			}
      			if (!angular.isUndefined($scope.additionals['searchTermFoodProductFamily'])) {
      					$scope.additionals['searchTermFoodProductFamily'] = '';
      			}

            if (!angular.isUndefined($scope.modelsData)) {
                angular.forEach($scope.modelsData, function (item, key) {
                    if (!angular.isUndefined($scope.modelsData[key].ingredient_name)) {
                        $scope.modelsData[key].ingredient_name = $scope.modelsData[key].ingredient_name.toLowerCase();
                    }
                    if (!angular.isUndefined($scope.additionals['searchTermGoodsCategoryMultiple'])) {
                      if (!angular.isUndefined($scope.additionals['searchTermGoodsCategoryMultiple'][key])) {
                          $scope.additionals['searchTermGoodsCategoryMultiple'][key] = '';
                      }
                    }
                    if (!angular.isUndefined($scope.additionals['searchTermFoodProductFamilyMultiple'])) {
                      if (!angular.isUndefined($scope.additionals['searchTermFoodProductFamilyMultiple'][key])) {
            					    $scope.additionals['searchTermFoodProductFamilyMultiple'][key] = '';
                      }
                    }
                });
            }
        }

        /* reports */
        if($rootScope.settings.enable_packaging == 1) {
            $scope.nonDisplay = 0;
        } else {
            $scope.nonDisplay = 1;
        }
        $scope.printReport = $window;
        $scope.isLoadingPrinter = false;
        $scope.printPreview = function (ev, path, availableColumns, columns) {

            $scope.isLoadingPrinter = true;
            var popup = $scope.printReport.open('', '_blank', 'width=800,height=300,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no,top=50');
            popup.document.open();

            Crud.search($scope.search, path, 1, 'p')
                .success(function (data) {
                    $scope.isLoadingPagination = false;
                    $scope.isLoadingPrinter = false;

                    $scope.additionals['buttonDisabledPagination'] = false;
                    var printColumns = {};
                    if (!angular.isUndefined(availableColumns) && availableColumns.length > 0) {
                        angular.forEach(columns, function (item, index) {
                            if (availableColumns.indexOf(index) >= 0) {
                                printColumns[index] = item;
                            }
                        });
                    } else {
                        printColumns = columns;
                    }
                    var title = 'Raport ';
                    if($scope.search['reportType'] == 'reportDetail') {
                        title = title + 'detaliat';
                    }
                    if($scope.search['reportType'] == 'reportGeneral') {
                        title = title + 'general';
                    }
                    title = title + '  ';
                    if ($scope.search['dateFrom']) {
                        title = title + moment($scope.search['dateFrom']).format('DD/MM/YY');
                    }
                    if ($scope.search['timeFrom']) {
                        title = title + moment($scope.search['timeFrom']).format(' HH:mm:ss');
                    }
                    if ($scope.search['dateFrom'] || $scope.search['timeFrom']) {
                        title = title + '   ';
                    }
                    if ($scope.search['dateTo']) {
                        title = title + moment($scope.search['dateTo']).format('DD/MM/YY');
                    }
                    if ($scope.search['timeTo']) {
                        title = title + moment($scope.search['timeTo']).format(' HH:mm:ss');
                    }

                    var html = '<div class="report-print">';
                    var orders = data.data;
                    if (orders.length > 0) {
                        html = html + '<table><tr>';
                        html = html + '<th>Nr.</th>';
                        angular.forEach(printColumns, function (itemColumn, keyColumn) {
                            if(!itemColumn['nonDisplay']) {
                                html = html + '<th>' + itemColumn['label'] + '</th>';
                            }
                        });
                        html = html + '</tr>';

                        var total_ingredient_quantity = 0;
                        var total = 0;

                        angular.forEach(orders, function (item, key) {
                            html = html + '<tr>';
                            var keys = key + 1;
                            html = html + '<td>' + keys + '</td>';
                            angular.forEach(printColumns, function (itemColumn, keyColumn) {
                                if(!itemColumn['nonDisplay']) {
                                    if (itemColumn['filterType'] == 'select') {
                                        if (!angular.isUndefined(item[keyColumn]) && item[keyColumn] != '') {
                                            html = html + '<td>' + $scope.additionals['associativeColumn'](printColumns[keyColumn], item[keyColumn]) + '</td>';
                                        } else {
                                            html = html + '<td></td>';
                                        }
                                    } else {
                                        if (!angular.isUndefined(item[keyColumn]) && item[keyColumn] != '') {
                                            html = html + '<td>' + item[keyColumn] + '</td>';
                                        } else {
                                            var prod = '';
                                            if(keyColumn == 'recipe_unit' || keyColumn == 'recipe_quantity' || keyColumn == 'product_name' || keyColumn == 'product_quantity' || keyColumn == 'total_consume') {
                                                angular.forEach(item['products'], function (itemProd, keyProd) {
                                                  if(keyColumn == 'recipe_unit'){
                                                    itemProd[keyColumn] = $scope.additionals['associativeColumn']($scope.additionals['recipeUnits'], parseInt(itemProd[keyColumn]));
                                                  }
                                                  prod = prod + ' ' + itemProd[keyColumn] + '<br>';
                                                });
                                                html = html + '<td>' + prod + '</td>';
                                            }

                                        }
                                    }
                                }
                            });
                            html = html + '</tr>';

                            total_ingredient_quantity = total_ingredient_quantity + parseFloat(item['total_ingredient_quantity']);
                            total = total + parseFloat(item['total']);

                        });

                        html = html + '<tr>';
                        html = html + '<td>Total</td>';
                        angular.forEach(printColumns, function (itemColumn, keyColumn) {
                            if(!itemColumn['nonDisplay']) {
                                if (keyColumn == 'total_consume') {
                                    html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total, 4) + '</td>';
                                } else if (keyColumn == 'total_ingredient_quantity') {
                                    html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_ingredient_quantity, 4) + '</td>';
                                } else if (keyColumn == 'recipe_quantity') {
                                    html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_ingredient_quantity, 4) + '</td>';
                                } else if (keyColumn == 'total') {
                                    html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total, 4) + '</td>';
                                } else {
                                    html = html + '<td></td>';
                                }
                            }
                        });
                        html = html + '</tr>';

                        html = html + '</table>';
                    }

                    popup.document.write('<!DOCTYPE html><html><head><title>'+ title +'</title>'
                        + '<link rel="stylesheet" type="text/css" href="/css/print-preview.css" />'
                        + '</head><body onload="window.print(); window.close();">'
                        + html
                        + '</body></html>');
                    //popup.document.close();

                }).error(function (data) {
                $scope.isLoadingPagination = false;
                $scope.errors = data.errors;
            });

        }

        if($location.path() == $scope.path+'/reportDetail') {
            $scope.columns = {
                'ingredient_name':{'label':'Ingredient', 'filter':1, 'filterType':'input'},
                'recipe_quantity':{'label':'Cantitate ingrediente', 'filter':1, 'filterType':'input'},
                'recipe_unit':{'label':'Unitate de masura', 'filter':1, 'filterType':'input'},
                'product_name':{'label':'Produse', 'filter':1, 'filterType':'input'},
                'product_quantity':{'label':'Nr. produse in care apare ingredientul', 'filter':1, 'filterType':'input'},
                'total_consume':{'label':'Total partial', 'filter':1, 'filterType':'input'},
                'total':{'label':'Total consum', 'filter':1, 'filterType':'input'}
            };

            $scope.search['reportType'] = 'reportDetail';
            $scope.additionals['reportType'] = 'reportDetail';
            $scope.title = 'Vanzari produse / Raport detaliat';
            $scope.classAction = 'td-small';
            $scope.search.order = 'asc';
        }

        $scope.changeColumns = function (reportTypeGeneral) {
            $scope.classAction = 'td-small';
            if(reportTypeGeneral == 'ingredient_name') {
                $scope.columns = {
                    'ingredient_name':{'label':'Ingredient', 'filter':1, 'filterType':'input'},
                    'total_ingredient_quantity':{'label':'Cantitate ingrediente', 'filter':1, 'filterType':'input'},
                    'total_product_quantity':{'label':'Nr. produse in care apare ingredientul', 'filter':1, 'filterType':'input'},
                    'total':{'label':'Total consum', 'filter':1, 'filterType':'input'}
                };
            }
            if(reportTypeGeneral == 'day') {
                $scope.columns = {
                    'date':{'label':'Data', 'filter':1, 'filterType':'input'},
                    'total_ingredient_quantity':{'label':'Cantitate ingrediente', 'filter':1, 'filterType':'input'},
                    'total_product_quantity':{'label':'Nr. produse in care apare ingredientul', 'filter':1, 'filterType':'input'},
                    'total':{'label':'Total consum', 'filter':1, 'filterType':'input'}
                };
            }

        }

        if($location.path() == $scope.path+'/reportGeneral') {
            $scope.search.reportTypeGeneral = 'ingredient_name';
            if (angular.isUndefined($scope.search.reportTypeGeneral)) { $scope.search.reportTypeGeneral = 'ingredient_name';}
            $scope.additionals.reportTypeGeneral = $scope.search.reportTypeGeneral;
            $scope.searchModel = function (ev, path) {
                $scope.searchControl = true;
                $scope.last = 0;
                $scope.firstTime = 1;
                $scope.firstLoad = 0;
                $scope.getPaginateModel(path, 1, $scope.defaultItem);
                $scope.changeColumns($scope.search.reportTypeGeneral);
                $scope.additionals.reportTypeGeneral = $scope.search.reportTypeGeneral;
            }
            $scope.controlGetOrder = false;
            $scope.search['reportType'] = 'reportGeneral';
            $scope.additionals['reportType'] = 'reportGeneral';
            $scope.title = 'Vanzari produse / Raport Consum Generic';
            $scope.classAction = 'td-small';
            $scope.search.order = 'asc';
        }

        /* show model report general */
        $scope.additionals['getCount'] = function(i, arr) {
            var iCount = iCount || 0;
            for (var j = 0; j < arr.length; j++) {
                if (arr[j] == i) {
                    iCount++;
                }
            }
            return iCount;
        }

        $scope.cancelSearchReport = function (ev, path, reportType) {
            $scope.search = {};

            if($scope.searchControl == true) {
                if(!angular.isUndefined(reportType)) {
                    $scope.search['reportType'] = reportType;
                    $scope.additionals['reportType'] = reportType;
                    if(reportType == 'reportGeneral') {
                        $scope.search.reportTypeGeneral = 'ingredient_name';
                        $scope.changeColumns($scope.search.reportTypeGeneral);
                        $scope.additionals.reportTypeGeneral = $scope.search.reportTypeGeneral;
                    }
                }
                $scope.getPaginateModel(path, 1, $scope.defaultItem);
            }
            angular.element(document.querySelector('.expand-collapse-content')).slideToggle('200',function() {
                angular.element(document.querySelector('#collapse i')).toggleClass('fa-minus fa-plus');
            });
            angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
            angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
            angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
            angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
            var form = document.getElementById('search-form');
            form.reset();

            $timeout($scope.removeDate, 500);
        }

        /* add multiple bar code forms */
        $scope.additionals['barCodes'] = [{}];
        $scope.additionals['cloneItem'] = function (model, modelLength, key) {
            var itemToClone = {};
            if(!angular.isUndefined(key)) {
                if(angular.isUndefined($scope.additionals[model][key]) ) {
                    $scope.additionals[model][key] = [{}];
                }
                $scope.additionals[model][key].push(itemToClone);
            } else {
                $scope.additionals[model].push(itemToClone);
            }
        }

        $scope.additionals['removeItem'] = function (itemIndex, modelBarCode, key) {

          console.log(itemIndex)
          console.log(modelBarCode)
          console.log($scope.additionals[modelBarCode])
            if(!angular.isUndefined($scope.errors) ) {
                if(!angular.isUndefined($scope.errors['barCodes.' + itemIndex + '.bar_code']) ) {
                    delete $scope.errors['barCodes.' + itemIndex + '.bar_code'];
                }
                if(!angular.isUndefined($scope.errors['barCodes.' + itemIndex + '.bar_code_id']) ) {
                    delete $scope.errors['barCodes.'+itemIndex+'.bar_code_id'];
                }
            }

            if(!angular.isUndefined(key)) {
                $scope.interm = [];
                angular.forEach($scope.additionals[modelBarCode][key], function (itemy, indexy) {
                    $scope.interm[indexy] = {
                        'bar_code_id' : itemy['bar_code_id'],
                        'bar_code' : itemy['bar_code']
                    };
                });
                $scope.interms = [];
                angular.forEach($scope.interm, function (itemyy, indexyy) {
                    $scope.interms.push({
                        'bar_code_id' : itemyy['bar_code_id'],
                        'bar_code' : itemyy['bar_code']
                    });
                });
                $scope.interms.splice(itemIndex, 1);
                $scope.additionals[modelBarCode][key] = $scope.interms;

                $timeout(function() {
                    $scope.modelsData[key].barCodes = $scope.additionals[modelBarCode][key];
                }, 100);

            } else {
                $scope.interm = [];
                angular.forEach($scope.additionals[modelBarCode], function (itemy, indexy) {
                    $scope.interm[indexy] = {
                        'bar_code_id' : itemy['bar_code_id'],
                        'bar_code' : itemy['bar_code']
                    };
                });
                $scope.interms = [];
                angular.forEach($scope.interm, function (itemyy, indexyy) {
                    $scope.interms.push({
                        'bar_code_id' : itemyy['bar_code_id'],
                        'bar_code' : itemyy['bar_code']
                    });
                });
                $scope.interms.splice(itemIndex, 1);
                $scope.additionals[modelBarCode] = $scope.interms;

                $timeout(function() {
                    $scope.modelData.barCodes = $scope.additionals[modelBarCode];
                }, 100);
           }
        }

        $scope.additionals['function'] = function(ev, model) {
          if (!angular.isUndefined($scope.selected) && $scope.action == 'updatemultiple') {
              angular.forEach(model, function (item, key) {
                  if(angular.isUndefined(item.barCodes) || item.barCodes.length == 0) {
                      item.barCodes = [{}];
                  }
                  $scope.additionals['barCodes'][key] = item.barCodes;
    					});
          } else {
              if(angular.isUndefined($scope.modelData.barCodes) || $scope.modelData.barCodes.length == 0) {
                  $scope.modelData.barCodes = [{}];
              }
              $scope.additionals['barCodes'] = $scope.modelData.barCodes;
          }
        }


	}]
);
